import { requestSaga } from 'common/utils/generators';
import resources from 'common/constants/resources';
import dataProvider from 'store/dataProvider';
import { actionTypes } from '../reducer';

function* fetchSimCards() {
  yield requestSaga({
    actionType: actionTypes.getList,
    request: dataProvider.getList,
    resource: resources.simCard.list,
  });
}

export default fetchSimCards;
